import { Tag } from 'antd';

interface StatusBadgeProps {
  status: string;
  colorMap?: Record<string, string>;
}

const DEFAULT_COLORS: Record<string, string> = {
  active: 'green',
  inactive: 'default',
  enabled: 'green',
  disabled: 'default',
  healthy: 'green',
  unhealthy: 'red',
  warning: 'orange',
  unknown: 'default',
};

export function StatusBadge({ status, colorMap }: StatusBadgeProps) {
  const colors = { ...DEFAULT_COLORS, ...colorMap };
  const color = colors[status] || 'default';

  return (
    <Tag color={color}>
      {status.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())}
    </Tag>
  );
}
